import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function startsAndEndsWithValidator(storedValue: string, inputValue: string): boolean {
    const firstTwoDigits = storedValue.substring(0, 2); // First 2 characters of storedValue
    const lastThreeDigits = storedValue.substring(storedValue.length - 3); // Last 3 characters of storedValue
    console.log({ firstTwoDigits, lastThreeDigits, storedValue })
    // Check if input starts with the first 2 digits and ends with the last 3 digits
    if (inputValue.startsWith(firstTwoDigits) && inputValue.endsWith(lastThreeDigits)) {
        return true;
    } else {
        return false
    }
}


export function panNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        const regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
        if (value && regex.test(value.toUpperCase())) {
            return null;
        } else {
            return { invalid: true };
        }
    };
}